var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnBoardingClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1378 17.9615C18.5308 18.0925 18.9555 17.8801 19.0865 17.4872C19.2175 17.0942 19.0051 16.6695 18.6122 16.5385L18.1378 17.9615ZM15 16.125H14.25C14.25 16.4478 14.4566 16.7344 14.7628 16.8365L15 16.125ZM15.75 11.4209C15.75 11.0067 15.4142 10.6709 15 10.6709C14.5858 10.6709 14.25 11.0067 14.25 11.4209H15.75ZM18.6122 16.5385L15.2372 15.4135L14.7628 16.8365L18.1378 17.9615L18.6122 16.5385ZM15.75 16.125V11.4209H14.25V16.125H15.75ZM23.25 15C23.25 19.5563 19.5563 23.25 15 23.25V24.75C20.3848 24.75 24.75 20.3848 24.75 15H23.25ZM15 23.25C10.4437 23.25 6.75 19.5563 6.75 15H5.25C5.25 20.3848 9.61522 24.75 15 24.75V23.25ZM6.75 15C6.75 10.4437 10.4437 6.75 15 6.75V5.25C9.61522 5.25 5.25 9.61522 5.25 15H6.75ZM15 6.75C19.5563 6.75 23.25 10.4437 23.25 15H24.75C24.75 9.61522 20.3848 5.25 15 5.25V6.75Z",
    fill: "#E33745"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnBoardingClock);
export default __webpack_public_path__ + "static/media/onBoardingClock.dfbce8ad37b7e777ff6eb53a4242b4f8.svg";
export { ForwardRef as ReactComponent };